import axios from '../../../context/axiosConfig'
import { useState, useEffect } from 'react';
import { usePaginationBezPrzekazania } from '../../../context/PaginationContextBezPrzekazania';
const WplywyGetList = () => {
    const {pagination, setPagination} = usePaginationBezPrzekazania()
    const [data, setData] = useState([])
    useEffect(() => {
      setPagination({...pagination, loading: true})
      const fetchData = async () => {
          const response = await axios.post("/wplywybezprzekazania/get/list", {
            pagination: pagination
          });
          console.log(response.data)
          setPagination({...pagination, loading: false})
          setData(response.data)
      }
      fetchData()
    },[pagination.current, pagination.pagesize, pagination.reload, pagination.search, pagination.specialfilter])
    return data
  };
export default WplywyGetList;